import { shadowTypes } from "../styles/UnitShadow";
import BaseURL from "./images/Hosting-BaseURL";

const attackoLantern1AImage = `${BaseURL}/Special/Pumpkinfolk/Attack o Lantern 1 A.png`;
const attackoLantern1APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Attack o Lantern 1 A.png`;

const attackoLantern2AImage = `${BaseURL}/Special/Pumpkinfolk/Attack o Lantern 2 A.png`;
const attackoLantern2APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Attack o Lantern 2 A.png`;

const attackoLantern3AImage = `${BaseURL}/Special/Pumpkinfolk/Attack o Lantern 3 A.png`;
const attackoLantern3APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Attack o Lantern 3 A.png`;

const attackoLantern4AImage = `${BaseURL}/Special/Pumpkinfolk/Attack o Lantern 4 A.png`;
const attackoLantern4APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Attack o Lantern 4 A.png`;

const zumpkin1AImage = `${BaseURL}/Special/Pumpkinfolk/Zumpkin 1 A.png`;
const zumpkin1APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Zumpkin 1 A.png`;

const zumpkin2AImage = `${BaseURL}/Special/Pumpkinfolk/Zumpkin 2 A.png`;
const zumpkin2APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Zumpkin 2 A.png`;

const zumpkin3AImage = `${BaseURL}/Special/Pumpkinfolk/Zumpkin 3 A.png`;
const zumpkin3APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Zumpkin 3 A.png`;

const zumpkin4AImage = `${BaseURL}/Special/Pumpkinfolk/Zumpkin 4 A.png`;
const zumpkin4APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Zumpkin 4 A.png`;

const zumpkin5AImage = `${BaseURL}/Special/Pumpkinfolk/Zumpkin 5 A.png`;
const zumpkin5APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Zumpkin 5 A.png`;

const zumpkin6AImage = `${BaseURL}/Special/Pumpkinfolk/Zumpkin 6 A.png`;
const zumpkin6APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Zumpkin 6 A.png`;

const zumpkin7AImage = `${BaseURL}/Special/Pumpkinfolk/Zumpkin 7 A.png`;
const zumpkin7APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Zumpkin 7 A.png`;

const pumpkultist1AImage = `${BaseURL}/Special/Pumpkinfolk/Pumpkultist 1 A.png`;
const pumpkultist1APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Pumpkultist 1 A.png`;

const pumpkultist2AImage = `${BaseURL}/Special/Pumpkinfolk/Pumpkultist 2 A.png`;
const pumpkultist2APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Pumpkultist 2 A.png`;

const pumpkultist3AImage = `${BaseURL}/Special/Pumpkinfolk/Pumpkultist 3 A.png`;
const pumpkultist3APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Pumpkultist 3 A.png`;

const pumpkultist4AImage = `${BaseURL}/Special/Pumpkinfolk/Pumpkultist 4 A.png`;
const pumpkultist4APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Pumpkultist 4 A.png`;

const pumpkultist5AImage = `${BaseURL}/Special/Pumpkinfolk/Pumpkultist 5 A.png`;
const pumpkultist5APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Pumpkultist 5 A.png`;

const pumpkultist6AImage = `${BaseURL}/Special/Pumpkinfolk/Pumpkultist 6 A.png`;
const pumpkultist6APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Pumpkultist 6 A.png`;

const pumpkultist7AImage = `${BaseURL}/Special/Pumpkinfolk/Pumpkultist 7 A.png`;
const pumpkultist7APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Pumpkultist 7 A.png`;

const pumpkultist8AImage = `${BaseURL}/Special/Pumpkinfolk/Pumpkultist 8 A.png`;
const pumpkultist8APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Pumpkultist 8 A.png`;

const kingsGourd1AImage = `${BaseURL}/Special/Pumpkinfolk/KingsGourd 1 A.png`;
const kingsGourd1BImage = `${BaseURL}/Special/Pumpkinfolk/KingsGourd 1 B.png`;
const kingsGourd1APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/KingsGourd 1 A.png`;
const kingsGourd1BPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/KingsGourd 1 B.png`;

const kingsGourd2AImage = `${BaseURL}/Special/Pumpkinfolk/KingsGourd 2 A.png`;
const kingsGourd2BImage = `${BaseURL}/Special/Pumpkinfolk/KingsGourd 2 B.png`;
const kingsGourd2APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/KingsGourd 2 A.png`;
const kingsGourd2BPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/KingsGourd 2 B.png`;

const greatPumpkin1AImage = `${BaseURL}/Special/Pumpkinfolk/Great Pumpkin 1 A.png`;
const greatPumpkin1BImage = `${BaseURL}/Special/Pumpkinfolk/Great Pumpkin 1 B.png`;
const greatPumpkin1APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Great Pumpkin 1 A.png`;
const greatPumpkin1BPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Great Pumpkin 1 B.png`;

const vine1AImage = `${BaseURL}/Special/Pumpkinfolk/Vine 1 A.png`;
const vine1APreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Vine 1 A.png`;

const arachnolanternAImage = `${BaseURL}/Special/Pumpkinfolk/Arachnolantern A.png`;
const arachnolanternBImage = `${BaseURL}/Special/Pumpkinfolk/Arachnolantern B.png`;
const arachnolanternCImage = `${BaseURL}/Special/Pumpkinfolk/Arachnolantern C.png`;
const arachnolanternAPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Arachnolantern A - dark.png`;
const arachnolanternBPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Arachnolantern B - dark.png`;
const arachnolanternCPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Arachnolantern C - dark.png`;

const headlessHorsemanImage = `${BaseURL}/Special/Pumpkinfolk/Headless Horseman.png`;
const headlessHorsemanPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Headless Horseman - dark.png`;

const scarecrow1AImage = `${BaseURL}/Special/Pumpkinfolk/Scarecrow 1A.png`;
const scarecrow1BImage = `${BaseURL}/Special/Pumpkinfolk/Scarecrow 1B.png`;
const scarecrow1BPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Scarecrow 1B dark.png`;

const scarecrow2AImage = `${BaseURL}/Special/Pumpkinfolk/Scarecrow 2A.png`;
const scarecrow2BImage = `${BaseURL}/Special/Pumpkinfolk/Scarecrow 2B.png`;
const scarecrow2BPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Scarecrow 2B dark.png`;

const scarecrow3AImage = `${BaseURL}/Special/Pumpkinfolk/Scarecrow 3A.png`;
const scarecrow3BImage = `${BaseURL}/Special/Pumpkinfolk/Scarecrow 3B.png`;
const scarecrow3BPreviewImage = `${BaseURL}/Special/Pumpkinfolk/previews/Scarecrow 3B dark.png`;

const mapDisableRestrictions = (variant) => ({
    ...variant,
    // Seasonal Free Mode
    // legendary: false,
    // previewSrc: null,
});

const mapFreePumpkinfolkVariants = (unit) => ({
    ...unit,
    variants: unit.variants
        .map(mapDisableRestrictions),
});

export default [
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "25px",
            right: "13px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Scarecrow",
                src: scarecrow1AImage,
                isExtraLarge: true,
                tags: [
                    "scarecrow",
                    "brown",
                    "golem",
                ],
            },
            {
                variant: "B",
                unitNumber: "1",
                filePrefix: "Scarecrow",
                src: scarecrow1BImage,
                previewSrc: scarecrow1BPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "scarecrow",
                    "brown",
                    "golem",
                    "pumpkin",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "25px",
            right: "13px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "2",
                filePrefix: "Scarecrow",
                src: scarecrow2AImage,
                isExtraLarge: true,
                tags: [
                    "scarecrow",
                    "brown",
                    "golem",
                    "pitchfork",
                ],
            },
            {
                variant: "B",
                unitNumber: "2",
                filePrefix: "Scarecrow",
                src: scarecrow2BImage,
                previewSrc: scarecrow2BPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "scarecrow",
                    "brown",
                    "golem",
                    "pitchfork",
                    "pumpkin",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "25px",
            right: "13px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "3",
                filePrefix: "Scarecrow",
                src: scarecrow3AImage,
                isExtraLarge: true,
                tags: [
                    "scarecrow",
                    "brown",
                    "golem",
                    "scythe",
                ],
            },
            {
                variant: "B",
                unitNumber: "3",
                filePrefix: "Scarecrow",
                src: scarecrow3BImage,
                previewSrc: scarecrow3BPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "scarecrow",
                    "brown",
                    "golem",
                    "scythe",
                    "pumpkin",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SUPREMELY_LARGE,
            bottom: "28px",
            right: "-32px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Arachnolantern",
                src: arachnolanternAImage,
                previewSrc: arachnolanternAPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "plant",
                    "green",
                    "spider",
                    "pumpkin",
                    "orange",
                    "halloween",
                ],
            },
            {
                variant: "B",
                unitNumber: "1",
                filePrefix: "Arachnolantern",
                src: arachnolanternBImage,
                previewSrc: arachnolanternBPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "plant",
                    "spider",
                    "green",
                    "pumpkin",
                    "orange",
                    "halloween",
                ],
            },
            {
                variant: "C",
                unitNumber: "1",
                filePrefix: "Arachnolantern",
                src: arachnolanternCImage,
                previewSrc: arachnolanternCPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "plant",
                    "spider",
                    "green",
                    "pumpkin",
                    "orange",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "3px",
            right: "60px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Headless Horseman",
                src: headlessHorsemanImage,
                previewSrc: headlessHorsemanPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "ghost",
                    "animal",
                    "horse",
                    "sword",
                    "orange",
                    "pumpkin",
                    "halloween",
                    "grey",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "33px",
            right: "31px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Attack o Lantern",
                src: attackoLantern1AImage,
                previewSrc: attackoLantern1APreviewImage,
                legendary: true,
                tags: [
                    "spider",
                    "pumpkin",
                    "orange",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "28px",
            right: "39px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "2",
                filePrefix: "Attack o Lantern",
                src: attackoLantern2AImage,
                previewSrc: attackoLantern2APreviewImage,
                legendary: true,
                tags: [
                    "spider",
                    "pumpkin",
                    "orange",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "32px",
            right: "44px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "3",
                filePrefix: "Attack o Lantern",
                src: attackoLantern3AImage,
                previewSrc: attackoLantern3APreviewImage,
                legendary: true,
                tags: [
                    "spider",
                    "pumpkin",
                    "orange",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "28px",
            right: "35px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "4",
                filePrefix: "Attack o Lantern",
                src: attackoLantern4AImage,
                previewSrc: attackoLantern4APreviewImage,
                legendary: true,
                tags: [
                    "spider",
                    "pumpkin",
                    "orange",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "14px",
            right: "26px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Zumpkin",
                src: zumpkin1AImage,
                previewSrc: zumpkin1APreviewImage,
                legendary: true,
                tags: [
                    "undead",
                    "vine",
                    "green",
                    "zombie",
                    "pumpkin",
                    "orange",
                    "halloween",
                    "weapon",
                    "hammer",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "35px",
            right: "30px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "2",
                filePrefix: "Zumpkin",
                src: zumpkin2AImage,
                previewSrc: zumpkin2APreviewImage,
                legendary: true,
                tags: [
                    "undead",
                    "vine",
                    "green",
                    "zombie",
                    "pumpkin",
                    "orange",
                    "halloween",
                    "weapon",
                    "scythe",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "17px",
            right: "32px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "3",
                filePrefix: "Zumpkin",
                src: zumpkin3AImage,
                previewSrc: zumpkin3APreviewImage,
                legendary: true,
                tags: [
                    "undead",
                    "vine",
                    "green",
                    "zombie",
                    "pumpkin",
                    "orange",
                    "halloween",
                    "weapon",
                    "axe",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "19px",
            right: "39px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "4",
                filePrefix: "Zumpkin",
                src: zumpkin4AImage,
                previewSrc: zumpkin4APreviewImage,
                legendary: true,
                tags: [
                    "undead",
                    "vine",
                    "green",
                    "zombie",
                    "pumpkin",
                    "orange",
                    "halloween",
                    "weapon",
                    "cleaver",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "23px",
            right: "47px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "5",
                filePrefix: "Zumpkin",
                src: zumpkin5AImage,
                previewSrc: zumpkin5APreviewImage,
                legendary: true,
                tags: [
                    "undead",
                    "vine",
                    "green",
                    "zombie",
                    "pumpkin",
                    "orange",
                    "halloween",
                    "weapon",
                    "cleaver",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "15px",
            right: "46px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "6",
                filePrefix: "Zumpkin",
                src: zumpkin6AImage,
                previewSrc: zumpkin6APreviewImage,
                legendary: true,
                tags: [
                    "undead",
                    "vine",
                    "green",
                    "zombie",
                    "pumpkin",
                    "orange",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "18px",
            right: "51px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "7",
                filePrefix: "Zumpkin",
                src: zumpkin7AImage,
                previewSrc: zumpkin7APreviewImage,
                legendary: true,
                tags: [
                    "undead",
                    "vine",
                    "green",
                    "zombie",
                    "pumpkin",
                    "orange",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "12px",
            right: "52px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Pumpkultist",
                src: pumpkultist1AImage,
                previewSrc: pumpkultist1APreviewImage,
                legendary: true,
                tags: [
                    "elf",
                    "pumpkin",
                    "orange",
                    "cloth",
                    "black",
                    "halloween",
                    "weapon",
                    "sword",
                    "woman",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "13px",
            right: "53px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "2",
                filePrefix: "Pumpkultist",
                src: pumpkultist2AImage,
                previewSrc: pumpkultist2APreviewImage,
                legendary: true,
                tags: [
                    "human",
                    "pumpkin",
                    "orange",
                    "cloth",
                    "black",
                    "halloween",
                    "weapon",
                    "sword",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "13px",
            right: "43px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "3",
                filePrefix: "Pumpkultist",
                src: pumpkultist3AImage,
                previewSrc: pumpkultist3APreviewImage,
                legendary: true,
                tags: [
                    "human",
                    "pumpkin",
                    "orange",
                    "cloth",
                    "black",
                    "halloween",
                    "weapon",
                    "sword",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "14px",
            right: "43px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "4",
                filePrefix: "Pumpkultist",
                src: pumpkultist4AImage,
                previewSrc: pumpkultist4APreviewImage,
                legendary: true,
                tags: [
                    "human",
                    "pumpkin",
                    "orange",
                    "cloth",
                    "black",
                    "halloween",
                    "weapon",
                    "dagger",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "11px",
            right: "53px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "5",
                filePrefix: "Pumpkultist",
                src: pumpkultist5AImage,
                previewSrc: pumpkultist5APreviewImage,
                legendary: true,
                tags: [
                    "dwarf",
                    "pumpkin",
                    "orange",
                    "cloth",
                    "black",
                    "halloween",
                    "weapon",
                    "axe",
                    "dagger",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "14px",
            right: "43px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "6",
                filePrefix: "Pumpkultist",
                src: pumpkultist6AImage,
                previewSrc: pumpkultist6APreviewImage,
                legendary: true,
                tags: [
                    "human",
                    "pumpkin",
                    "orange",
                    "cloth",
                    "black",
                    "halloween",
                    "weapon",
                    "sword",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "16px",
            right: "43px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "7",
                filePrefix: "Pumpkultist",
                src: pumpkultist7AImage,
                previewSrc: pumpkultist7APreviewImage,
                legendary: true,
                tags: [
                    "human",
                    "pumpkin",
                    "orange",
                    "cloth",
                    "black",
                    "halloween",
                    "weapon",
                    "dagger",
                    "torch",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "15px",
            right: "47px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "8",
                filePrefix: "Pumpkultist",
                src: pumpkultist8AImage,
                previewSrc: pumpkultist8APreviewImage,
                legendary: true,
                tags: [
                    "human",
                    "pumpkin",
                    "orange",
                    "cloth",
                    "black",
                    "halloween",
                    "weapon",
                    "dagger",
                    "torch",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "16px",
            right: "43px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "KingsGourd",
                src: kingsGourd1AImage,
                previewSrc: kingsGourd1APreviewImage,
                legendary: true,
                tags: [
                    "plant",
                    "golem",
                    "green",
                    "pumpkin",
                    "orange",
                    "vine",
                    "halloween",
                ],
            },
            {
                variant: "B",
                unitNumber: "1",
                filePrefix: "KingsGourd",
                src: kingsGourd1BImage,
                previewSrc: kingsGourd1BPreviewImage,
                legendary: true,
                tags: [
                    "plant",
                    "golem",
                    "green",
                    "pumpkin",
                    "orange",
                    "vine",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "16px",
            right: "43px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "2",
                filePrefix: "KingsGourd",
                src: kingsGourd2AImage,
                previewSrc: kingsGourd2APreviewImage,
                legendary: true,
                tags: [
                    "plant",
                    "golem",
                    "green",
                    "pumpkin",
                    "orange",
                    "vine",
                    "halloween",
                ],
            },
            {
                variant: "B",
                unitNumber: "2",
                filePrefix: "KingsGourd",
                src: kingsGourd2BImage,
                previewSrc: kingsGourd2BPreviewImage,
                legendary: true,
                tags: [
                    "plant",
                    "golem",
                    "green",
                    "pumpkin",
                    "orange",
                    "vine",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "15px",
            right: "47px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Great Pumpkin",
                src: greatPumpkin1AImage,
                previewSrc: greatPumpkin1APreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "plant",
                    "green",
                    "mound",
                    "pumpkin",
                    "orange",
                    "vine",
                    "halloween",
                ],
            },
            {
                variant: "B",
                unitNumber: "1",
                filePrefix: "Great Pumpkin",
                src: greatPumpkin1BImage,
                previewSrc: greatPumpkin1BPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "plant",
                    "mound",
                    "green",
                    "pumpkin",
                    "orange",
                    "vine",
                    "halloween",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "25px",
            right: "94px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Vine",
                src: vine1AImage,
                previewSrc: vine1APreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "plant",
                    "green",
                    "vine",
                ],
            },
        ]
    },
]
.map(mapFreePumpkinfolkVariants);
